module.exports = __webpack_public_path__ + "img/img2.b95cd0aa.png";